import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RedirectHomeStore {

}

export enum RedirectHomeStoreKeys {

}
